/**************************************************
 * Nombre:       Tarjeta_Producto_Metrica
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Chip, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";

const Tarjeta_Producto_Metrica = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 0, borderColor: '#00000030', pr: sCell ? 0 : 2, py: 2}}
        >

            <Grid container size={3}>
                <img src={item.img} width={'90%'}/>
            </Grid>

            <Grid container size={9}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                lineHeight: 1.1,
                                fontSize: 16,
                                cursor: 'pointer'
                            }}>{`${item.nombre}`}


                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: 12
                            }}>{`Talla/Tipo: ${item.varianteNombre}`}</Typography>


                    </Grid>

                    {item.etiquetas && item.etiquetas.length > 0 &&
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 1, fontSize: 12}}
                        >

                            {item.etiquetas.map((it, index) => {
                                return (
                                    <Chip key={index + '6'} label={it} size={'small'} color={'primary'}
                                          sx={{fontSize: 12}}/>
                                )
                            })}

                        </Grid>
                    }


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-end'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={3} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 14}}>{`Cant: ${item.cantidad}`}</Typography>
                            </Grid>

                            <Grid container size={9} sx={{mt: -1, mb: 1}}>
                                <Grid
                                    container
                                    justifyContent={'flex-end'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                >


                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                        <Typography
                                            sx={{fontWeight: 600, fontSize: 12, color: '#00000080', lineHeight: 1.1}}>

                                            {item.valorAntes && item.valorAntes > 0 ?

                                                <>

                                <span style={{
                                    paddingLeft: 0,
                                    fontSize: 11,
                                    color: '#00000080',
                                    fontWeight: 400,
                                }}>Antes: {formatoMoneda(item.valorAntes)} c/u</span>
                                                    <br/>
                                                </>

                                                :

                                                ''
                                            }

                                            Valor
                                            prendas</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>


                                        <Typography sx={{
                                            fontWeight: 600,
                                            fontSize: 14,
                                            lineHeight: 1.1
                                        }}>

                                            {formatoMoneda(item.cantidad * item.valor)}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Producto_Metrica